<template>
  <div class="tile is-ancestor">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <form v-on:submit.prevent="adduser">
          <h1 class="title">Edit File Info</h1>
          <div class="block">
            <label class="label">Name</label>
            <p class="control">
              <input v-model="file.name" class="input" type="name" placeholder="filename">
            </p>
            <label class="label">Tags</label>
            <p class="control has-icon has-icon-right">
              <input v-model="file.tags" class="input" type="text" placeholder="seo tags" value="tags">
            </p>
            <p class="control">
              <button class="button is-primary" v-on:click="updateFileInfo">Submit</button>
            </p>
          </div>
        </form>
      </article>
    </div>
  </div>
</template>


<script>
  export default {
    data () {
      return {
        file: {
          name: '',
          tags: '',
          randname: ''
        }
      }
    },
    methods: {
      updateFileInfo () {
        this.$http.post(
          '/api/v1/admin/file/edit',
          this.file
        ).then((response) => {
          console.log(response)
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    beforeCreate () {
      this.$http({
        url: '/api/v1/file/' + this.$route.params.fileid
      }).then((response) => {
        this.file = []
        this.file = response.data
      }).catch((error) => {
        console.log(error)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// FileEdit.vue?6ad31d1d